$ = require 'jquery'
Auth = require 'db/auth'
ClientVersion = require 'debug/client-version'
Controller = require 'controller'
DesktopNotification = require 'views/lib/desktop-notification'
Dialog = require 'views/lib/dialog'
HeaderAddMenuView = require 'views/header/header-add-menu-view'
HeaderChannelPicker = require 'views/header/header-channel-picker'
HeaderMemberMenuView = require 'views/header/header-member-menu-view'
HeaderEnterpriseAdminDashboardMenuView = require 'views/header/header-enterprise-admin-dashboard-menu-view'
HeaderNotificationListView = require 'views/notification/header-notification-list-view'
HeaderInfoMenuView = require 'views/header/header-info-menu-view'
ModelLoader = require 'db/model-loader'
Notification = require 'models/notification'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
getExperiment = require 'lib/experiments/simple-test'
Time = require 'lib/time'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
l = require 'lib/localize'
log = require 'debug/log'
createBoardHelpers = require 'views/board-create/helpers'
track = require 'debug/track'

ClientConfig = require 'debug/client-config'

memberTemplate = require 'views/templates/member'
headerUser = require 'views/templates/header_user'

module.exports = class HeaderMemberView extends View

  className: 'header-user'

  initialize: ->
    @listenTo @modelCache, 'add:Notification change:Notification remove:Notification', @renderUnreadNotifications
    @listenTo @model, 'change:showNps', @renderUnreadNotifications
    @listenTo @model, 'change:initials change:avatarHash change:avatarSource change:fullName change:username', @renderAvatar

    @idLastNotification = _.chain(@modelCache.all('Notification'))
      .pluck("id")
      .compact()
      .sort()
      .last()
      .value() ? ""

    @listenTo @modelCache, 'add:Notification', @showDesktopNotification

    super

  events:
    'click .js-open-header-info-menu': 'viewInfoMenu'
    'click .js-open-header-notifications-menu': 'viewNotificationsMenu'
    'click .js-open-enterprise-dashboard-menu': 'viewEnterpriseDashboardMenu'
    'click .js-open-header-member-menu': 'viewMemberMenu'
    'mouseenter .js-open-add-menu': 'preloadCreateBoardData'
    'click .js-open-add-menu': 'openAddMenu'
    'click .js-open-channel-picker': 'viewChannelPicker'

  render: ->
    log('render', "rendering header")
    isLoggedIn = Auth.isLoggedIn()
    data =
      hasCrown: @model.isFeatureEnabled('crown')
      showChannelPicker: isLoggedIn &&
        (@model.get('channels').allowed.length > 1 ||
        # If we're not on trello.com show the menu to make it easier to switch
        # A/B test configuration
        location.hostname != 'trello.com')
      escapedReturnUrl: Util.escapedReturnUrl()
      isEnterpriseAdmin: @model.isEnterpriseAdmin()
      isLoggedIn: isLoggedIn
      upsellEnabled: !ClientConfig.get('dontUpsell')

    @$el.html(headerUser(data))

    @renderUnreadNotifications()
    @renderAvatar()
    @renderMemberName()

    @

  renderMemberName: ->
    @$('.js-member-name').text(
      @model.get('fullName') ? @model.get('username')
    )

  renderAvatar: ->
    log('render', "rendering avatar")

    @$('.member').html(memberTemplate(@model.toJSON()))

    @

  renderUnreadNotifications: ->
    unreadCount = Notification.unreadCount(@modelCache)

    showCount = getExperiment('manualNotifications').get('count')
    displayCount = if unreadCount <= 99 # We only load the first 99
      unreadCount
    else
      '\uD83D\uDE31' # You have too many notifications
    @$('.js-open-header-notifications-menu')
    .toggleClass('new-notifications', unreadCount > 0)
    .toggleClass('display-count', showCount)
    .attr('data-count', displayCount)
    .toggleClass('other-notifications', unreadCount == 0 && @model.shouldShowSurvey())

    # Tell the contoller to update the title, to reflect the new unread count
    Controller.title()

    @

  viewInfoMenu: (e) ->
    track("Header", "Information Menu", "Open Information Menu")
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-open-header-info-menu')
      view: HeaderInfoMenuView
      options:
        model: @model
        modelCache: @modelCache

    return

  viewEnterpriseDashboardMenu: (e) ->
    Util.stop(e)

    track("Header", "Enterprise Dashboard Menu", "Open Enterprise Dashboard Menu")

    view = new HeaderEnterpriseAdminDashboardMenuView({ model: Auth.me(), @modelCache })

    PopOver.toggle
      elem: @$('.js-open-enterprise-dashboard-menu')
      view: view

    return

  viewNotificationsMenu: (e) ->
    Util.stop(e)

    if $('.mod-notifications').length
      track("Header", "Notifications Menu", "Close Notifications Menu")
    else
      track("Header", "Notifications Menu", "Open Notifications Menu", Notification.unreadCount(this.modelCache))

    if @model.shouldShowSurvey()
      @model.trackShowSurvey()

    hideFn = if getExperiment('manualNotifications').get('markRead') \
      then ->
      else _.bind @model.clearAllNotifications, @model

    isShowCards = getExperiment('cardNotifications').get('showCards')

    if Dialog.isVisible
      Dialog.hide()
      return

    Dialog.show
      elem: @$('.js-open-header-notifications-menu')
      hide: hideFn
      maxWidth: if isShowCards then 420 else 450
      displayType: if isShowCards then 'mod-notifications mod-cards' else 'mod-notifications'
      opacity: 0
      closeOnBlur: true
      hardToClose: false
      onScrollInner: -> PopOver.hide()
      reactElement: React.createElement HeaderNotificationListView,
        key: 'header-notifications'
        member: @model,
        markAllRead: _.bind @model.clearAllNotifications, @model
        showSurvey: @model.shouldShowSurvey(),
        onDismissSurvey: =>
          @model.dismissSurvey()
        submitSurvey: (surveyData) =>
          @model.submitSurvey(surveyData)
      options:
        model: @model
        modelCache: @modelCache

    return

  preloadCreateBoardData: (e) ->
    withBackground = getExperiment('createBoardWithBackground')?.get('enabled')
    if withBackground
      createBoardHelpers.preloadData()

  openAddMenu: (e) ->
    Util.stop(e)

    track("Header", "Add Menu", "Open")

    PopOver.toggle
      elem: @$('.js-open-add-menu')
      view: new HeaderAddMenuView({ model: Auth.me(), @modelCache })

    return

  viewMemberMenu: (e) ->
    Util.stop(e)

    track("Header", "User Menu", "Open User Menu")
    view = new HeaderMemberMenuView({ model: Auth.me(), @modelCache })

    PopOver.toggle
      elem: @$('.js-open-header-member-menu')
      view: view

    return

  viewChannelPicker: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-open-channel-picker')
      view: new HeaderChannelPicker({ model: Auth.me(), @modelCache })

    return

  showDesktopNotification: (notification) ->
    if !DesktopNotification.enabled()
      return

    # Only do a desktop notification if this notification is *newer* then the
    # last one we've seen
    if notification.id <= @idLastNotification
      return

    @idLastNotification = notification.id

    Promise.try ->
      # It's possible that we've just re-connected our websocket and we're
      # receiving old notifications.  This commonly happens when a laptop
      # wakes up.
      delta = Date.now() - Time.serverToClient(notification.get('date'))
      if delta < Util.getMs(minutes: 1)
        # The notification just happened, so consider the notification to
        # be current
        notification
      else
        # The notification happened a while ago, so it's possible that
        # it's actually been read.  Fetch the latest version of the
        # notification
        ModelLoader.loadNotification(notification.id)
    .then (latestNotification) ->
      if latestNotification.get('unread')
        new DesktopNotification(latestNotification)
    .done()



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-member-view.coffee